import { useEffect } from 'react'
import { NextPage } from 'next'

import { routes } from '~/config/routes'
import { useRouter } from 'next/router'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { accessToken } from '~/utils/access-token'

type Options = {
  redirectUrl?: string
}

export const withDonorAuth = <T extends {}>(
  PageComponent: NextPage<T>,
  {}: Options = {}
) => {
  const WithDonorAuth: NextPage<T> = pageProps => {
    const router = useRouter()

    useEffect(() => {
      if (router.query) {
        if (!accessToken.get('donor-portal')) {
          router.replace({
            pathname: routes.donorPortal.signIn,
            query: { email: router.query.email },
          })
        }
      }
    }, [router.query])

    return <PageComponent {...pageProps} />
  }

  return hoistNonReactStatics(WithDonorAuth, PageComponent)
}
